import { Link } from "react-router-dom";
import MarketingNav from "@/components/app/MarketingNav";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background">
      <MarketingNav />
      <section className="relative border-b border-border overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-6 lg:px-10 py-20 text-center" data-testid="payment-cancel">
          <XCircle className="w-12 h-12 mx-auto text-muted-foreground" strokeWidth={1.5} />
          <h1 className="font-semibold tracking-tight mt-6 text-4xl">No worries — checkout cancelled.</h1>
          <p className="text-muted-foreground mt-3 max-w-md mx-auto">
            Your card wasn&apos;t charged. The free plan is still solid — and Pro is here when you&apos;re ready.
          </p>
          <div className="mt-8 flex justify-center gap-3 flex-wrap">
            <Link to="/pricing"><Button className="rounded-none h-11 bg-foreground hover:bg-foreground/90" data-testid="payment-cancel-retry">Back to pricing</Button></Link>
            <Link to="/app"><Button variant="outline" className="rounded-none h-11">Go to app</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
